import * as React from "react";
import { useState, useEffect, useContext } from "react";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DataTable from "../components/table";
import FormMerchantTerminal from "../components/forms/MerchantTerminalForm";
import FormReport from "../components/forms/ReportForm";
import SearchTerminalForm from "../components/forms/SearchTerminalForm";
import IsoDailyReportForm from "../components/forms/IsoDailyReport";
import MerchantDailyReportForm from "../components/forms/MerchantDailyReport";
// import MerchantPeriodicReportForm from "../components/forms/MerchantPeriodicReport";
import MerchantPeriodicReport from "../components/forms/MerchantPeriodicReport/MerchantPeriodicReport";
import ClearingSettlementReportForm from "../components/forms/ClearingSettlement";
import DailyIsoClearingSettlementReportForm from "../components/forms/DailyIsoClearingSettlement";
import TransactionDailyReportForm from "../components/forms/DailyTransactionsReport";
import TransactionSearchReport from "../components/forms/TransactionSearchReport/TransactionSearchReport";
import IsoEnrollmentForm from "../components/forms//iso_enrollment/IsoEnrollmentForm";
import AdminForm from "../components/forms/admin/admin";
import BusinessReport from "../components/forms/BusinessReport/BusinessReport";
import ListIcon from "@mui/icons-material/List";

import Logo from "../assets/images/blokko-logo.svg";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import AuthContext from "../context/AuthContext";
import { get } from "../services/apiService";

import AssessmentIcon from '@mui/icons-material/Assessment';
import StoreIcon from "@mui/icons-material/Store";
import SearchIcon from "@mui/icons-material/Search";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BarChartIcon from "@mui/icons-material/BarChart";
import DescriptionIcon from "@mui/icons-material/Description";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import LoadEnrollment from "../components/lists/LoadEnrollment/LoadEnrollment";
import ConfirmModal from "../components/confirmModal/ConfirmModal";
import AddBoxIcon from "@mui/icons-material/AddBox";
import LogoutIcon from "@mui/icons-material/Logout";

// Nuevos imports para breadcrumbs y user info
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Chip from "@mui/material/Chip";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BusinessIcon from "@mui/icons-material/Business";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import ButtonBase from "@mui/material/ButtonBase";
import EditIcon from "@mui/icons-material/Edit";
import BrandingContext from "../context/BrandingContext";
import DashboardLogoDialog from "../layout/DashboardLogoDialog";
import AcquirerForm from "../components/forms/acquirer/AcquirerForm";
import AcquirerList from "../components/lists/Acquierer/Acquirer";
import MerchantList from "../components/lists/MerchantAndTerminal/Merchant";
import IsoEnrollmentList from "../components/lists/IsoEnrollment/IsoEnrollment";
import { Snackbar as CustomSnackbar } from "../components/snackbar";
import MerchantAndTerminals from "../components/forms/MerchantAndTerminals/MerchantAndTerminals";
import { useDispatch } from "react-redux";
import PeriodicIso from "../components/forms/periodicIso/PeriodicIso";
import PeriodicAcquirerReport from "../components/forms/PeriodicAcquirerReport/PeriodicAcquirerReport";
import PeriodicBillingReport from "../components/forms/PeriodicBillingReport/PeriodicBillingReport";
import MonthlyReport from "../components/forms/monthlyReport/MonthlyReport";
import BillingInfo from "../components/lists/BillingInfo/BillingInfo";
import BillingInfoForm from "../components/forms/BillingInfo/BillingInfoForm";
import BillingSettingsForm from "../components/forms/BillingSettings/BillingSettingsForm";
import Invoices from "../components/lists/Invoices/Invoices";
import InvoiceForm from "../components/forms/Invoices/InvoiceForm";
import Exchanges from "../components/lists/Exchanges/Exchanges";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import SettingsIcon from "@mui/icons-material/Settings";
import GlobalExchanges from "../components/lists/GlobalExchanges/GlobalExchanges";
import KycStatusList from "../components/lists/KycStatusList/KycStatusList";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

const StyledImage = styled("img")({
  width: "100%",
  height: "auto",
});

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="#">
        Blokko
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const drawerWidth = 260;

// Drawer header: room kept on each side for the collapse chevron, and the largest box a logo can fill.
// The width is in px, not %, because the logo's wrapper shrinks to the image: a % max-width there
// collapses SVGs without width/height (like blokko-logo.svg) to 0.
const LOGO_SIDE_GUTTER = 44;
const LOGO_MAX_HEIGHT = 48;
const LOGO_MAX_WIDTH = drawerWidth - 2 * LOGO_SIDE_GUTTER;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  borderRadius: 0,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

// Componente para breadcrumbs
const NavigationBreadcrumbs = ({ nameSection, userInfo, acquirerData }) => {
  const sections = nameSection.split(" - ");

  return (
    <Box>
      <Box
        sx={{
          p: 1.5,
          backgroundColor: "background.paper",
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <AccountCircleIcon sx={{ color: "primary.main", fontSize: 20 }} />
            <Typography variant="body2" fontWeight={500} color="text.primary">
              {userInfo.email}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <BusinessIcon sx={{ color: "primary.main", fontSize: 16 }} />
            <Typography variant="body2" color="text.secondary">
              {acquirerData.acquirerId} - {acquirerData.acquirerName}
            </Typography>
          </Box>
        </Box>

        <Chip
          label={userInfo["acquirer-rol-data"]}
          size="small"
          color="primary"
          variant="outlined"
          sx={{ fontWeight: 500 }}
        />
      </Box>
      <Box
        sx={{
          p: 2,
          backgroundColor: "background.default",
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
            "& .MuiBreadcrumbs-separator": {
              color: "text.secondary",
            },
          }}
        >
          <Link
            underline="hover"
            color="inherit"
            href="#"
            sx={{
              color: "primary.main",
              fontWeight: 500,
              "&:hover": { color: "primary.dark" },
            }}
          >
            Dashboard
          </Link>
          {sections.map((section, index) => (
            <Typography
              key={index}
              color={
                index === sections.length - 1 ? "text.primary" : "text.secondary"
              }
              fontWeight={index === sections.length - 1 ? 600 : 400}
              sx={{ fontSize: "0.9rem" }}
            >
              {section}
            </Typography>
          ))}
        </Breadcrumbs>
      </Box>
    </Box>
  );
};

export default function Dashboard() {
  const { userInfo, acquirerData, token, logout } = useContext(AuthContext);
  const { logoUrl, loaded: brandingLoaded, editableLevel } =
    useContext(BrandingContext);
  const [logoFailed, setLogoFailed] = useState(false);
  const [logoDialogOpen, setLogoDialogOpen] = useState(false);

  useEffect(() => {
    setLogoFailed(false);
  }, [logoUrl]);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const [data, setData] = useState({});
  const [openSnack, setSnackOpen] = useState(false);
  const [rol, setRol] = useState(false);
  const [messageSnack, setMessageOpen] = useState(
    "No transaction for this date",
  );
  const [selectedOption, setSelectedOption] = useState("");
  const [severity, setSeverity] = useState("warning");
  const [nameSection, setNameSection] = useState("Home");
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [submenuMerchantTerminal, setSubmenuMerchantTerminal] = useState(null);
  const [submenuReportsOpen, setSubmenuReportsOpen] = useState(false);
  const [submenuAdministrativeOpen, setSubmenuAdministrativeOpen] =
    useState(false);
  const [submenuReportsOption, setSubmenuReportsOption] = useState(null);
  const [submenuAdministrativeOption, setSubmenuAdministrativeOption] =
    useState(null);
  const [role, setRole] = useState(null);
  const [billingConfig, setBillingConfig] = useState(null);

  useEffect(() => {
    if (userInfo) {
      setRole(userInfo["acquirer-rol-data"]);
      // setRole("merchant");
    }
  }, [userInfo]);

  // Fetch merchants/{merchant_id}/billing only when role is merchant or merchant-iso
  useEffect(() => {
    const isMerchantRole = role === "merchant" || role === "merchant-iso";
    const merchantId = acquirerData?.merchantID;

    if (!isMerchantRole || !merchantId || !token) {
      if (!isMerchantRole) setBillingConfig(null);
      return;
    }

    let cancelled = false;
    get(`/merchants/${merchantId}/billing`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((data) => {
        if (!cancelled) {
          setBillingConfig({
            allow_billing: Boolean(data?.allow_billing),
            wallet_validation: Boolean(data?.wallet_validation),
          });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setBillingConfig({ allow_billing: false, wallet_validation: false });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [role, acquirerData?.merchantID, token]);

  const hasAccess = (allowedRoles) => allowedRoles.includes(role);

  const toggleAdministrativeSubmenu = () => {
    setSubmenuAdministrativeOpen((prev) => !prev);
  };

  useEffect(() => {
    setData({});
  }, [selectedOption]);

  const toggleReportsSubmenu = () => {
    setSubmenuReportsOpen((prev) => !prev);
  };

  const toggleSubmenu = () => {
    setSubmenuOpen((prev) => !prev);
  };

  useEffect(() => {
    if (acquirerData?.acquirerRol === -99) {
      setRol(true);
    }
  }, [acquirerData]);

  const handleClose = () => {
    setSnackOpen(false);
  };

  const toggleDrawer = () => {
    setOpen(!open);
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <Box sx={{ display: "flex" }}>
      <ConfirmModal />
      <CustomSnackbar />
      <DashboardLogoDialog
        open={logoDialogOpen}
        onClose={() => setLogoDialogOpen(false)}
      />
      <Snackbar
        open={openSnack}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={severity} onClose={handleClose}>
          {messageSnack}
        </Alert>
      </Snackbar>
      <CssBaseline />
      <AppBar position="absolute" open={open}>
        <Toolbar
          sx={{
            pr: "24px", // keep right padding when drawer closed
          }}
        >
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer}
            sx={{
              marginRight: "36px",
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </IconButton>

          {/* Título simplificado */}
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            sx={{ flexGrow: 1, fontWeight: 600 }}
          >
            Blokko Dashboard
          </Typography>

          {/* Botón de logout */}
          <Button
            color="inherit"
            onClick={handleLogout}
            sx={{
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
            }}
          >
            <LogoutIcon />
          </Button>
        </Toolbar>
      </AppBar>

      <Drawer variant="permanent" open={open}>
        <Toolbar
          disableGutters
          sx={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // Same padding on both sides so the logo is centered on the whole panel, not beside the chevron.
            px: `${LOGO_SIDE_GUTTER}px`,
          }}
        >
          <Tooltip
            title={editableLevel ? "Change logo" : ""}
            placement="bottom"
            // Not interactive, so it never covers the collapse chevron.
            disableInteractive
          >
            <ButtonBase
              aria-label={editableLevel ? "Change dashboard logo" : undefined}
              tabIndex={editableLevel ? 0 : -1}
              disableRipple={!editableLevel}
              onClick={() => editableLevel && setLogoDialogOpen(true)}
              sx={{
                position: "relative",
                // Collapsed drawer: only the app bar menu button reopens it.
                visibility: open ? "visible" : "hidden",
                cursor: editableLevel ? "pointer" : "default",
                width: "100%",
                height: LOGO_MAX_HEIGHT + 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 1,
                "&:hover .logo-edit, &.Mui-focusVisible .logo-edit": {
                  opacity: 1,
                },
              }}
            >
              {/* Wraps the image tightly so the edit badge sits on the logo's corner, whatever its shape. */}
              <Box
                sx={{
                  position: "relative",
                  display: "inline-flex",
                  maxWidth: LOGO_MAX_WIDTH,
                  maxHeight: LOGO_MAX_HEIGHT,
                }}
              >
                <StyledImage
                  src={logoUrl && !logoFailed ? logoUrl : Logo}
                  alt={logoUrl && !logoFailed ? "Logo" : "Blokko"}
                  onError={() => setLogoFailed(true)}
                  style={{
                    // Hidden until branding loads so the Blokko logo doesn't flash before a custom one.
                    visibility: brandingLoaded ? "visible" : "hidden",
                    // Fixed height gives SVGs without width/height (blokko-logo.svg) a size; width follows
                    // the aspect ratio and wide logos are letterboxed by objectFit.
                    width: "auto",
                    height: LOGO_MAX_HEIGHT,
                    maxWidth: LOGO_MAX_WIDTH,
                    objectFit: "contain",
                  }}
                />
                {editableLevel && (
                  <Box
                    className="logo-edit"
                    sx={{
                      position: "absolute",
                      right: -10,
                      bottom: -8,
                      width: 22,
                      height: 22,
                      borderRadius: "50%",
                      bgcolor: "primary.main",
                      color: "primary.contrastText",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: 1,
                      opacity: 0,
                      transition: "opacity 150ms",
                    }}
                  >
                    <EditIcon sx={{ fontSize: 14 }} />
                  </Box>
                )}
              </Box>
            </ButtonBase>
          </Tooltip>
          <IconButton
            onClick={toggleDrawer}
            sx={{
              position: "absolute",
              right: 4,
              top: "50%",
              transform: "translateY(-50%)",
              visibility: open ? "visible" : "hidden",
            }}
          >
            <ChevronLeftIcon />
          </IconButton>
        </Toolbar>
        <Divider />
        <List component="nav">
          {(hasAccess(["admin", "ISO", "acquirer"]) ||
            (hasAccess(["merchant", "merchant-iso"]) &&
              billingConfig?.allow_billing === true)) && (
            <>
              <ListItemButton onClick={toggleSubmenu}>
                <ListItemIcon>
                  <StoreIcon />
                </ListItemIcon>
                <ListItemText primary="Merchant & Terminal" />
              </ListItemButton>
              {submenuOpen && (
                <List component="div" disablePadding>
                  {hasAccess(["admin", "ISO", "acquirer"]) && (
                    <ListItemButton
                      sx={{ pl: 4 }}
                      selected={submenuMerchantTerminal === "merchant_area"}
                      onClick={() => {
                        setSubmenuMerchantTerminal("merchant_area");
                        setSelectedOption("merchant_area");
                        setNameSection("Merchant & Terminal - Merchant");
                      }}
                    >
                      <ListItemIcon>
                        <ListIcon />
                      </ListItemIcon>
                      <ListItemText primary="Merchant Area" />
                    </ListItemButton>
                  )}
                  {hasAccess(["merchant", "merchant-iso"]) &&
                    billingConfig?.allow_billing === true && (
                      <ListItemButton
                        sx={{ pl: 4 }}
                        selected={submenuMerchantTerminal === "billing_info"}
                        onClick={() => {
                          setSubmenuMerchantTerminal("billing_info");
                          setSelectedOption("billing_info");
                          setNameSection("Merchant & Terminal - Customer Info");
                        }}
                      >
                        <ListItemIcon>
                          <AccountBalanceWalletIcon />
                        </ListItemIcon>
                        <ListItemText primary="Customer Info" />
                      </ListItemButton>
                    )}
                  {hasAccess(["merchant", "merchant-iso"]) &&
                    billingConfig?.allow_billing === true && (
                      <ListItemButton
                        sx={{ pl: 4 }}
                        selected={
                          submenuMerchantTerminal === "billing_settings"
                        }
                        onClick={() => {
                          setSubmenuMerchantTerminal("billing_settings");
                          setSelectedOption("billing_settings");
                          setNameSection(
                            "Merchant & Terminal - Billing Settings",
                          );
                        }}
                      >
                        <ListItemIcon>
                          <SettingsIcon />
                        </ListItemIcon>
                        <ListItemText primary="Billing Settings" />
                      </ListItemButton>
                    )}
                  {hasAccess(["merchant", "merchant-iso"]) &&
                    billingConfig?.allow_billing === true && (
                      <ListItemButton
                        sx={{ pl: 4 }}
                        selected={
                          submenuMerchantTerminal === "kyc_verifications"
                        }
                        onClick={() => {
                          setSubmenuMerchantTerminal("kyc_verifications");
                          setSelectedOption("kyc_verifications");
                          setNameSection(
                            "Merchant & Terminal - KYC Verifications",
                          );
                        }}
                      >
                        <ListItemIcon>
                          <VerifiedUserIcon />
                        </ListItemIcon>
                        <ListItemText primary="KYC Verifications" />
                      </ListItemButton>
                    )}
                </List>
              )}
            </>
          )}

          {/* Reports */}
          {hasAccess([
            "admin",
            "ISO",
            "merchant",
            "acquirer-iso",
            "acquirer",
            "merchant-iso",
          ]) && (
            <>
              <ListItemButton onClick={toggleReportsSubmenu}>
                <ListItemIcon>
                  <AssessmentIcon />
                </ListItemIcon>
                <ListItemText primary="Reports" />
              </ListItemButton>
              {submenuReportsOpen && (
                <List component="div" disablePadding>
                  {hasAccess([
                    "admin",
                    "acquirer",
                    "merchant",
                    "merchant-iso",
                  ]) && (
                    <>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        selected={
                          submenuReportsOption === "merchant_periodic_report"
                        }
                        onClick={() => {
                          setSubmenuReportsOption("merchant_periodic_report");
                          setSelectedOption("merchant_periodic_report");
                          setNameSection("Reports - Date Range Report");
                        }}
                      >
                        <ListItemIcon>
                          <AccountBalanceIcon />
                        </ListItemIcon>
                        <ListItemText primary="Date Range" />
                      </ListItemButton>
                    </>
                  )}
                  {hasAccess([
                    // "admin",
                    "merchant",
                    "merchant-iso",
                  ]) &&
                    billingConfig?.allow_billing === true && (
                      <>
                        <ListItemButton
                          sx={{ pl: 4 }}
                          selected={submenuReportsOption === "billing_report"}
                          onClick={() => {
                            setSubmenuReportsOption("billing_report");
                            setSelectedOption("billing_report");
                            setNameSection("Reports - Billing Report");
                          }}
                        >
                          <ListItemIcon>
                            <AssessmentIcon />
                          </ListItemIcon>
                          <ListItemText primary="Billing Range" />
                        </ListItemButton>
                      </>
                    )}
                  {hasAccess(["admin", "ISO"]) && (
                    <>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        selected={
                          submenuReportsOption === "periodic_iso_report"
                        }
                        onClick={() => {
                          setSubmenuReportsOption("periodic_iso_report");
                          setSelectedOption("periodic_iso_report");
                          setNameSection(
                            `Reports -  Date range ${
                              role === "admin" ? "(ISO)" : ""
                            } Report`,
                          );
                        }}
                      >
                        <ListItemIcon>
                          <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={`Date range ${
                            role === "admin" ? "(ISO)" : ""
                          }`}
                        />
                      </ListItemButton>
                    </>
                  )}
                  {hasAccess(["admin", "acquirer-iso"]) && (
                    <>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        selected={
                          submenuReportsOption ===
                          "periodic_acquirer_iso_report"
                        }
                        onClick={() => {
                          setSubmenuReportsOption(
                            "periodic_acquirer_iso_report",
                          );
                          setSelectedOption("periodic_acquirer_iso_report");
                          setNameSection(
                            `Reports -  Date range ${
                              role === "admin" ? "(Acquirer ISO)" : ""
                            } Report`,
                          );
                        }}
                      >
                        <ListItemIcon>
                          <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={`Date range ${
                            role === "admin" ? "(Acquirer ISO)" : ""
                          }`}
                        />
                      </ListItemButton>
                    </>
                  )}

                  {hasAccess(["admin", "acquirer"]) && (
                    <ListItemButton
                      sx={{ pl: 4 }}
                      selected={
                        submenuReportsOption ===
                        "periodic_daily_clearing_settlement"
                      }
                      onClick={() => {
                        setSubmenuReportsOption(
                          "periodic_daily_clearing_settlement",
                        );
                        setSelectedOption("periodic_daily_clearing_settlement");
                        setNameSection(
                          "Reports - Periodic Daily Clearing Settlement",
                        );
                      }}
                    >
                      <ListItemIcon>
                        <BarChartIcon />
                      </ListItemIcon>
                      <ListItemText primary="Clearing Settlement" />
                    </ListItemButton>
                  )}

                  {hasAccess(["admin", "acquirer-iso"]) && (
                    <ListItemButton
                      sx={{ pl: 4 }}
                      selected={submenuReportsOption === "monthly_report"}
                      onClick={() => {
                        setSubmenuReportsOption("monthly_report");
                        setSelectedOption("monthly_report");
                        setNameSection("Reports - Residuals Report");
                      }}
                    >
                      <ListItemIcon>
                        <DescriptionIcon />
                      </ListItemIcon>
                      <ListItemText primary="Residuals Report" />
                    </ListItemButton>
                  )}

                  {hasAccess([
                    "admin",
                    "merchant-iso",
                    "ISO",
                    "acquirer-iso",
                    "acquirer",
                    "merchant",
                  ]) && (
                    <>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        selected={submenuReportsOption === "transaction_search"}
                        onClick={() => {
                          setSubmenuReportsOption("transaction_search");
                          setSelectedOption("transaction_search");
                          setNameSection("Reports - Transaction Search Report");
                        }}
                      >
                        <ListItemIcon>
                          <SearchIcon />
                        </ListItemIcon>
                        <ListItemText primary="Transaction Search" />
                      </ListItemButton>
                    </>
                  )}
                </List>
              )}
            </>
          )}
          {/* Administrative */}
          {hasAccess(["admin", "acquirer-iso"]) && (
            <>
              <ListItemButton onClick={toggleAdministrativeSubmenu}>
                <ListItemIcon>
                  <AdminPanelSettingsIcon />
                </ListItemIcon>
                <ListItemText primary="Administrative" />
              </ListItemButton>
              {submenuAdministrativeOpen && (
                <List component="div" disablePadding>
                  {hasAccess(["admin", "acquirer-iso"]) && (
                    <ListItemButton
                      sx={{ pl: 4 }}
                      selected={
                        submenuAdministrativeOption === "iso_enrollment_area"
                      }
                      onClick={() => {
                        setSubmenuAdministrativeOption("iso_enrollment_area");
                        setSelectedOption("iso_enrollment_area");
                        setNameSection("Administrative - ISO Enrollment");
                      }}
                    >
                      <ListItemIcon>
                        <ListIcon />
                      </ListItemIcon>
                      <ListItemText primary="ISO Enrollment" />
                    </ListItemButton>
                  )}

                  {hasAccess(["admin"]) && (
                    <ListItemButton
                      sx={{ pl: 4 }}
                      selected={submenuAdministrativeOption === "kyc_verifications"}
                      onClick={() => {
                        setSubmenuAdministrativeOption("kyc_verifications");
                        setSelectedOption("kyc_verifications");
                        setNameSection("Administrative - KYC Verifications");
                      }}
                    >
                      <ListItemIcon>
                        <VerifiedUserIcon />
                      </ListItemIcon>
                      <ListItemText primary="KYC Verifications" />
                    </ListItemButton>
                  )}

                  {hasAccess(["admin"]) && (
                    <ListItemButton
                      sx={{ pl: 4 }}
                      selected={submenuAdministrativeOption === "acquirer_list"}
                      onClick={() => {
                        setSubmenuAdministrativeOption("acquirer_list");
                        setSelectedOption("acquirer_list");
                        setNameSection("Administrative - Acquirer List");
                      }}
                    >
                      <ListItemIcon>
                        <AddBoxIcon />
                      </ListItemIcon>
                      <ListItemText primary="Acquirer" />
                    </ListItemButton>
                  )}

                  {hasAccess(["admin"]) && (
                    <ListItemButton
                      sx={{ pl: 4 }}
                      selected={submenuAdministrativeOption === "admin_report"}
                      onClick={() => {
                        setSubmenuAdministrativeOption("admin_report");
                        setSelectedOption("admin_report");
                        setNameSection("Administrative - Admin Report");
                      }}
                    >
                      <ListItemIcon>
                        <CurrencyExchangeIcon />
                      </ListItemIcon>
                      <ListItemText primary="Admin Report" />
                    </ListItemButton>
                  )}

                  {hasAccess(["admin"]) && (
                    <ListItemButton
                      sx={{ pl: 4 }}
                      selected={submenuAdministrativeOption === "business_report"}
                      onClick={() => {
                        setSubmenuAdministrativeOption("business_report");
                        setSelectedOption("business_report");
                        setNameSection("Administrative - Business Report");
                      }}
                    >
                      <ListItemIcon>
                        <AssessmentIcon />
                      </ListItemIcon>
                      <ListItemText primary="Business Report" />
                    </ListItemButton>
                  )}

                  {hasAccess(["admin"]) && (
                    <ListItemButton
                      sx={{ pl: 4 }}
                      selected={submenuAdministrativeOption === "global_exchanges"}
                      onClick={() => {
                        setSubmenuAdministrativeOption("global_exchanges");
                        setSelectedOption("global_exchanges");
                        setNameSection("Administrative - Global Exchanges");
                      }}
                    >
                      <ListItemIcon>
                        <CurrencyExchangeIcon />
                      </ListItemIcon>
                      <ListItemText primary="Global Exchanges" />
                    </ListItemButton>
                  )}
                </List>
              )}
            </>
          )}
        </List>
      </Drawer>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: "100vh",
          overflow: "auto",
        }}
      >
        <Toolbar />
        <NavigationBreadcrumbs
          nameSection={nameSection}
          userInfo={userInfo}
          acquirerData={acquirerData}
        />
        <Container
          maxWidth="lg"
          sx={{ mt: 4, mb: 4, backgroundColor: "background.paper", borderRadius: "10px" }}
        >
          {selectedOption === "merchant_terminal_enrollment" && (
            <FormMerchantTerminal
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )}
          {selectedOption === "merchant_terminal_new" && (
            <MerchantAndTerminals
              goBack={() => {
                setSubmenuMerchantTerminal(true);
                setSelectedOption("merchant_area");
                setNameSection("Merchant & Terminal - Merchant & Terminal");
              }}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
              setSubmenuMerchantTerminal={setSubmenuMerchantTerminal}
              setSelectedOption={setSelectedOption}
              setNameSection={setNameSection}
            />
          )}
          {selectedOption === "merchant_terminal_load_enrollment" && (
            <LoadEnrollment
              setSubmenuMerchantTerminal={setSubmenuMerchantTerminal}
              setSelectedOption={setSelectedOption}
              setNameSection={setNameSection}
            />
          )}
          {selectedOption === "merchant_terminal_edit_unenrollment" && (
            <SearchTerminalForm
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
              mode="merchant_search"
            />
          )}
          {selectedOption === "merchant_terminal_iso_search" && (
            <SearchTerminalForm
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
              mode="iso_search"
            />
          )}
          {selectedOption === "merchant_area" && (
            <MerchantList
              setSubmenuMerchantTerminal={setSubmenuMerchantTerminal}
              setSelectedOption={setSelectedOption}
              setNameSection={setNameSection}
            />
          )}
          {selectedOption === "billing_info" && (
            <BillingInfo
              setSubmenuMerchantTerminal={setSubmenuMerchantTerminal}
              setSelectedOption={setSelectedOption}
              setNameSection={setNameSection}
            />
          )}
          {selectedOption === "billing_info_form" && (
            <BillingInfoForm
              setSubmenuMerchantTerminal={setSubmenuMerchantTerminal}
              setSelectedOption={setSelectedOption}
              setNameSection={setNameSection}
              goBack={() => {
                setSubmenuMerchantTerminal("billing_info");
                setSelectedOption("billing_info");
                setNameSection("Merchant & Terminal - Customer Info");
              }}
            />
          )}
          {selectedOption === "billing_settings" && (
            <BillingSettingsForm
              setSubmenuMerchantTerminal={setSubmenuMerchantTerminal}
              setSelectedOption={setSelectedOption}
              setNameSection={setNameSection}
              goBack={() => {
                setSubmenuMerchantTerminal("billing_settings");
                setSelectedOption("billing_settings");
                setNameSection("Merchant & Terminal - Billing Settings");
              }}
            />
          )}
          {selectedOption === "invoices" && (
            <Invoices
              setSubmenuMerchantTerminal={setSubmenuMerchantTerminal}
              setSelectedOption={setSelectedOption}
              setNameSection={setNameSection}
            />
          )}
          {selectedOption === "invoice_form" && (
            <InvoiceForm
              setSubmenuMerchantTerminal={setSubmenuMerchantTerminal}
              setSelectedOption={setSelectedOption}
              setNameSection={setNameSection}
              goBack={() => {
                setSubmenuMerchantTerminal("invoices");
                setSelectedOption("invoices");
                setNameSection("Merchant & Terminal - Invoices");
              }}
            />
          )}
          {selectedOption === "kyc_verifications" && <KycStatusList />}

          {selectedOption === "exchanges" && (
            <Exchanges
              setSubmenuMerchantTerminal={setSubmenuMerchantTerminal}
              setSelectedOption={setSelectedOption}
              setNameSection={setNameSection}
            />
          )}
          {selectedOption === "daily_report" && (
            <FormReport
              type="acquirer"
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )}

          {selectedOption === "iso_report" && (
            <IsoDailyReportForm
              type="iso"
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )}

          {selectedOption === "merchant_report" && (
            <MerchantDailyReportForm
              type="merchant"
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )}

          {/* Old Merchant Periodic Report Form */}
          {/* {selectedOption === "merchant_periodic_report" && (
            <MerchantPeriodicReportForm
              type="merchant_periodic"
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )} */}
          {selectedOption === "merchant_periodic_report" && (
            <MerchantPeriodicReport />
          )}

          {selectedOption === "periodic_iso_report" && (
            <PeriodicIso
              type="merchant_periodic"
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )}

          {selectedOption === "periodic_acquirer_iso_report" && (
            <PeriodicAcquirerReport
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )}

          {selectedOption === "billing_report" && (
            <PeriodicBillingReport
              type="billing_report"
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )}

          {selectedOption === "monthly_report" && (
            <MonthlyReport
              type="monthly"
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )}

          {selectedOption === "transaction_report" && (
            <TransactionDailyReportForm
              type="transaction"
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )}

          {selectedOption === "transaction_search" && (
            <TransactionSearchReport />
          )}

          {selectedOption === "periodic_daily_clearing_settlement" && (
            <ClearingSettlementReportForm
              type="periodic_daily_clearing_settlement"
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )}

          {selectedOption === "daily_isos_clearing_settlement" && (
            <DailyIsoClearingSettlementReportForm
              type="daily_isos_clearing_settlement"
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )}

          {selectedOption === "iso_enrollment" && (
            <IsoEnrollmentForm
              type="iso_enrollment"
              goBack={() => {
                setSubmenuAdministrativeOpen(true);
                setSubmenuAdministrativeOption("iso_enrollment_area");
                setSelectedOption("iso_enrollment_area");
                setNameSection("Administrative - ISO Enrollment");
              }}
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )}

          {selectedOption === "iso_enrollment_area" && (
            <IsoEnrollmentList
              setSubmenuAdministrativeOpen={setSubmenuAdministrativeOpen}
              setSubmenuAdministrativeOption={setSubmenuAdministrativeOption}
              setSelectedOption={setSelectedOption}
              setNameSection={setNameSection}
            />
          )}

          {selectedOption === "acquirer_form" && (
            <AcquirerForm
              goBack={() => {
                setSubmenuAdministrativeOpen(true);
                setSubmenuAdministrativeOption("acquirer_list");
                setSelectedOption("acquirer_list");
                setNameSection("Administrative - Acquirer List");
              }}
              setSubmenuAdministrativeOpen={setSubmenuAdministrativeOpen}
              setSubmenuAdministrativeOption={setSubmenuAdministrativeOption}
              setSelectedOption={setSelectedOption}
              setNameSection={setNameSection}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )}

          {selectedOption === "acquirer_list" && (
            <AcquirerList
              setSubmenuAdministrativeOpen={setSubmenuAdministrativeOpen}
              setSubmenuAdministrativeOption={setSubmenuAdministrativeOption}
              setSelectedOption={setSelectedOption}
              setNameSection={setNameSection}
            />
          )}

          {selectedOption === "admin_report" && (
            <AdminForm
              type="admin_report"
              setData={setData}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )}

          {selectedOption === "business_report" && <BusinessReport />}

          {selectedOption === "global_exchanges" && (
            <GlobalExchanges
              goBack={() => {
                setSubmenuAdministrativeOpen(true);
                setSubmenuAdministrativeOption("global_exchanges");
                setSelectedOption("global_exchanges");
                setNameSection("Administrative - Global Exchanges");
              }}
              setSubmenuAdministrativeOpen={setSubmenuAdministrativeOpen}
              setSubmenuAdministrativeOption={setSubmenuAdministrativeOption}
              setSelectedOption={setSelectedOption}
              setNameSection={setNameSection}
              setSnackOpen={setSnackOpen}
              setMessageOpen={setMessageOpen}
              setSeverity={setSeverity}
            />
          )}
        </Container>
        {data.holdings?.holding?.length > 0 && (
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Grid container spacing={3}>
              <DataTable data={data} />
            </Grid>
            <Copyright sx={{ pt: 4 }} />
          </Container>
        )}
      </Box>
    </Box>
  );
}
